export const LOGIN = "LOGIN";
export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const ADMIN_LOGIN_FAILED = "ADMIN_LOGIN_FAILED";

export const SET_AUTH = "SET_AUTH";

export const LOGOUT = "LOGOUT";

export const SET_PROXY_ID = "SET_PROXY_ID";

export const SET_SERVICE_TYPE = "SET_SERVICE_TYPE";

export const SET_RECORD = "SET_RECORD";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_START = "SIGN_UP_START";
export const TEMP_SIGN_UP_SUCCESS = "TEMP_SIGN_UP_SUCCESS";
export const SIGN_UP_FAILED = "SIGN_UP_FAILED";
export const TEMP_SIGN_UP_FAILED = "TEMP_SIGN_UP_FAILED";
export const RELOD_PHONEBOOKLIST = "RELOD_PHONEBOOKLIST";
export const RELOD_CONTACT = "RELOD_CONTACT";
export const RELOAD_CAMPAIGN = "RELOAD_CAMPAIGN";
export const BUTTON_CAMPAIGN = "BUTTON_CAMPAIGN";

export const TWO_FACTOR_AUTHENTICATION = "TWO_FACTOR_AUTHENTICATION";
